/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as FocusRouteImport } from './routes/_focus'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as SettingsRouteImport } from './routes/_settings'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppChangeSetsRouteImport } from './routes/_app/change-sets'
import { Route as AppDataQualityRouteImport } from './routes/_app/data-quality'
import { Route as AppImportsRouteImport } from './routes/_app/imports'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppSignaturesRouteImport } from './routes/_app/signatures'
import { Route as FocusOnboardingRouteImport } from './routes/_focus/onboarding'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicSetupRouteImport } from './routes/_public/setup'
import { Route as PublicStatusRouteImport } from './routes/_public/status'
import { Route as PublicVerifyRouteImport } from './routes/_public/verify'
import { Route as AppAppsIndexRouteImport } from './routes/_app/apps/index'
import { Route as AppAppsKeyRouteImport } from './routes/_app/apps/$key'
import { Route as AppAutomationsIndexRouteImport } from './routes/_app/automations/index'
import { Route as AppAutomationsRunsRouteImport } from './routes/_app/automations/runs'
import { Route as AppDashboardsIndexRouteImport } from './routes/_app/dashboards/index'
import { Route as AppDashboardsDashboardIdRouteImport } from './routes/_app/dashboards/$dashboardId'
import { Route as AppDocumentsClausesRouteImport } from './routes/_app/documents/clauses'
import { Route as AppDocumentsSequencesRouteImport } from './routes/_app/documents/sequences'
import { Route as AppEngagementsIndexRouteImport } from './routes/_app/engagements/index'
import { Route as AppLibraryIndexRouteImport } from './routes/_app/library/index'
import { Route as AppLibraryNewRouteImport } from './routes/_app/library/new'
import { Route as AppMeetingsIndexRouteImport } from './routes/_app/meetings/index'
import { Route as AppPagesIndexRouteImport } from './routes/_app/pages/index'
import { Route as AppPagesPageIdRouteImport } from './routes/_app/pages/$pageId'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as FocusComponentsIdRouteImport } from './routes/_focus/components/$id'
import { Route as FocusDecksDeckIdRouteImport } from './routes/_focus/decks/$deckId'
import { Route as FocusDocumentsIdRouteImport } from './routes/_focus/documents/$id'
import { Route as PublicBookSlugRouteImport } from './routes/_public/book/$slug'
import { Route as PublicFSlugRouteImport } from './routes/_public/f/$slug'
import { Route as PublicMeetingTokenRouteImport } from './routes/_public/meeting/$token'
import { Route as PublicPTokenRouteImport } from './routes/_public/p/$token'
import { Route as PublicPresentPresenterRouteImport } from './routes/_public/present/presenter'
import { Route as PublicRecordingTokenRouteImport } from './routes/_public/recording/$token'
import { Route as PublicSignTokenRouteImport } from './routes/_public/sign/$token'
import { Route as PublicTaskTokenRouteImport } from './routes/_public/task/$token'
import { Route as SettingsAccountIndexRouteImport } from './routes/_settings/account/index'
import { Route as SettingsAccountConnectionsRouteImport } from './routes/_settings/account/connections'
import { Route as SettingsAccountNotificationsRouteImport } from './routes/_settings/account/notifications'
import { Route as SettingsAccountPreferencesRouteImport } from './routes/_settings/account/preferences'
import { Route as SettingsAccountProfileRouteImport } from './routes/_settings/account/profile'
import { Route as SettingsAccountSecurityRouteImport } from './routes/_settings/account/security'
import { Route as SettingsAccountShortcutsRouteImport } from './routes/_settings/account/shortcuts'
import { Route as SettingsSettingsIndexRouteImport } from './routes/_settings/settings/index'
import { Route as SettingsSettingsActionLibraryRouteImport } from './routes/_settings/settings/action-library'
import { Route as SettingsSettingsAiRouteImport } from './routes/_settings/settings/ai'
import { Route as SettingsSettingsApiRouteImport } from './routes/_settings/settings/api'
import { Route as SettingsSettingsAppsRouteImport } from './routes/_settings/settings/apps'
import { Route as SettingsSettingsAuditRouteImport } from './routes/_settings/settings/audit'
import { Route as SettingsSettingsBrandingRouteImport } from './routes/_settings/settings/branding'
import { Route as SettingsSettingsCalendarRouteImport } from './routes/_settings/settings/calendar'
import { Route as SettingsSettingsComponentsRouteImport } from './routes/_settings/settings/components'
import { Route as SettingsSettingsConnectionsRouteImport } from './routes/_settings/settings/connections'
import { Route as SettingsSettingsDataQualityRouteImport } from './routes/_settings/settings/data-quality'
import { Route as SettingsSettingsDirectoryRouteImport } from './routes/_settings/settings/directory'
import { Route as SettingsSettingsEmailRouteImport } from './routes/_settings/settings/email'
import { Route as SettingsSettingsEngagementTypesRouteImport } from './routes/_settings/settings/engagement-types'
import { Route as SettingsSettingsGeneralRouteImport } from './routes/_settings/settings/general'
import { Route as SettingsSettingsGithubRouteImport } from './routes/_settings/settings/github'
import { Route as SettingsSettingsImportsRouteImport } from './routes/_settings/settings/imports'
import { Route as SettingsSettingsInstanceRouteImport } from './routes/_settings/settings/instance'
import { Route as SettingsSettingsJobsRouteImport } from './routes/_settings/settings/jobs'
import { Route as SettingsSettingsMailLogRouteImport } from './routes/_settings/settings/mail-log'
import { Route as SettingsSettingsMembersRouteImport } from './routes/_settings/settings/members'
import { Route as SettingsSettingsModulesRouteImport } from './routes/_settings/settings/modules'
import { Route as SettingsSettingsNotificationsRouteImport } from './routes/_settings/settings/notifications'
import { Route as SettingsSettingsOptionSetsRouteImport } from './routes/_settings/settings/option-sets'
import { Route as SettingsSettingsRecorderRouteImport } from './routes/_settings/settings/recorder'
import { Route as SettingsSettingsRolesRouteImport } from './routes/_settings/settings/roles'
import { Route as SettingsSettingsSchemaRouteImport } from './routes/_settings/settings/schema'
import { Route as SettingsSettingsSecurityRouteImport } from './routes/_settings/settings/security'
import { Route as SettingsSettingsSequencesRouteImport } from './routes/_settings/settings/sequences'
import { Route as SettingsSettingsServiceAccountsRouteImport } from './routes/_settings/settings/service-accounts'
import { Route as SettingsSettingsSignInRouteImport } from './routes/_settings/settings/sign-in'
import { Route as SettingsSettingsStorageRouteImport } from './routes/_settings/settings/storage'
import { Route as SettingsSettingsTaskTypesRouteImport } from './routes/_settings/settings/task-types'
import { Route as SettingsSettingsTeamsRouteImport } from './routes/_settings/settings/teams'
import { Route as SettingsSettingsWorkflowsRouteImport } from './routes/_settings/settings/workflows'
import { Route as AppDocumentsGeneratedJobIdRouteImport } from './routes/_app/documents/generated/$jobId'
import { Route as AppDocumentsVariantsTemplateIdRouteImport } from './routes/_app/documents/variants/$templateId'
import { Route as AppMeetingsRecordingsIndexRouteImport } from './routes/_app/meetings/recordings/index'
import { Route as AppMeetingsRecordingsIdRouteImport } from './routes/_app/meetings/recordings/$id'
import { Route as AppMeetingsTypesTypeIdRouteImport } from './routes/_app/meetings/types/$typeId'
import { Route as AppOObjectIndexRouteImport } from './routes/_app/o/$object/index'
import { Route as AppOObjectNewRouteImport } from './routes/_app/o/$object/new'
import { Route as FocusAutomationsWorkflowIdIndexRouteImport } from './routes/_focus/automations/$workflowId/index'
import { Route as FocusOObjectImportRouteImport } from './routes/_focus/o/$object/import'
import { Route as SettingsSettingsBlueprintsIndexRouteImport } from './routes/_settings/settings/blueprints/index'
import { Route as SettingsSettingsObjectsIndexRouteImport } from './routes/_settings/settings/objects/index'
import { Route as AppAutomationsWorkflowIdRunsRunIdRouteImport } from './routes/_app/automations/$workflowId/runs/$runId'
import { Route as AppDocumentsVariantTemplateIdRecordIdRouteImport } from './routes/_app/documents/variant/$templateId/$recordId'
import { Route as AppOObjectRRecordIdRouteImport } from './routes/_app/o/$object/r/$recordId'
import { Route as FocusOObjectFormsFormIdRouteImport } from './routes/_focus/o/$object/forms/$formId'
import { Route as FocusSettingsObjectsKeyLayoutRouteImport } from './routes/_focus/settings/objects/$key/layout'
import { Route as FocusSettingsTaskTypesKeyLayoutRouteImport } from './routes/_focus/settings/task-types/$key/layout'
import { Route as SettingsSettingsBlueprintsKeyConfigureRouteImport } from './routes/_settings/settings/blueprints/$key/configure'
import { Route as SettingsSettingsBlueprintsKeyUpgradeRouteImport } from './routes/_settings/settings/blueprints/$key/upgrade'
import { Route as SettingsSettingsObjectsKeyIndexRouteImport } from './routes/_settings/settings/objects/$key/index'
import { Route as SettingsSettingsObjectsKeyFieldsFieldKeyRouteImport } from './routes/_settings/settings/objects/$key/fields/$fieldKey'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const FocusRoute = FocusRouteImport.update({
  id: '/_focus',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppChangeSetsRoute = AppChangeSetsRouteImport.update({
  id: '/change-sets',
  path: '/change-sets',
  getParentRoute: () => AppRoute,
} as any)
const AppDataQualityRoute = AppDataQualityRouteImport.update({
  id: '/data-quality',
  path: '/data-quality',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsRoute = AppImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppSignaturesRoute = AppSignaturesRouteImport.update({
  id: '/signatures',
  path: '/signatures',
  getParentRoute: () => AppRoute,
} as any)
const FocusOnboardingRoute = FocusOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => FocusRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSetupRoute = PublicSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicStatusRoute = PublicStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => PublicRoute,
} as any)
const PublicVerifyRoute = PublicVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => PublicRoute,
} as any)
const AppAppsIndexRoute = AppAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AppRoute,
} as any)
const AppAppsKeyRoute = AppAppsKeyRouteImport.update({
  id: '/apps/$key',
  path: '/apps/$key',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsIndexRoute = AppAutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsRunsRoute = AppAutomationsRunsRouteImport.update({
  id: '/automations/runs',
  path: '/automations/runs',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsIndexRoute = AppDashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsDashboardIdRoute =
  AppDashboardsDashboardIdRouteImport.update({
    id: '/dashboards/$dashboardId',
    path: '/dashboards/$dashboardId',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocumentsClausesRoute = AppDocumentsClausesRouteImport.update({
  id: '/documents/clauses',
  path: '/documents/clauses',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsSequencesRoute = AppDocumentsSequencesRouteImport.update({
  id: '/documents/sequences',
  path: '/documents/sequences',
  getParentRoute: () => AppRoute,
} as any)
const AppEngagementsIndexRoute = AppEngagementsIndexRouteImport.update({
  id: '/engagements/',
  path: '/engagements/',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryIndexRoute = AppLibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryNewRoute = AppLibraryNewRouteImport.update({
  id: '/library/new',
  path: '/library/new',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIndexRoute = AppMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppPagesIndexRoute = AppPagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => AppRoute,
} as any)
const AppPagesPageIdRoute = AppPagesPageIdRouteImport.update({
  id: '/pages/$pageId',
  path: '/pages/$pageId',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRoute,
} as any)
const FocusComponentsIdRoute = FocusComponentsIdRouteImport.update({
  id: '/components/$id',
  path: '/components/$id',
  getParentRoute: () => FocusRoute,
} as any)
const FocusDecksDeckIdRoute = FocusDecksDeckIdRouteImport.update({
  id: '/decks/$deckId',
  path: '/decks/$deckId',
  getParentRoute: () => FocusRoute,
} as any)
const FocusDocumentsIdRoute = FocusDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => FocusRoute,
} as any)
const PublicBookSlugRoute = PublicBookSlugRouteImport.update({
  id: '/book/$slug',
  path: '/book/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicFSlugRoute = PublicFSlugRouteImport.update({
  id: '/f/$slug',
  path: '/f/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMeetingTokenRoute = PublicMeetingTokenRouteImport.update({
  id: '/meeting/$token',
  path: '/meeting/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPTokenRoute = PublicPTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPresentPresenterRoute = PublicPresentPresenterRouteImport.update({
  id: '/present/presenter',
  path: '/present/presenter',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRecordingTokenRoute = PublicRecordingTokenRouteImport.update({
  id: '/recording/$token',
  path: '/recording/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignTokenRoute = PublicSignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicTaskTokenRoute = PublicTaskTokenRouteImport.update({
  id: '/task/$token',
  path: '/task/$token',
  getParentRoute: () => PublicRoute,
} as any)
const SettingsAccountIndexRoute = SettingsAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountConnectionsRoute =
  SettingsAccountConnectionsRouteImport.update({
    id: '/account/connections',
    path: '/account/connections',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsAccountNotificationsRoute =
  SettingsAccountNotificationsRouteImport.update({
    id: '/account/notifications',
    path: '/account/notifications',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsAccountPreferencesRoute =
  SettingsAccountPreferencesRouteImport.update({
    id: '/account/preferences',
    path: '/account/preferences',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsAccountProfileRoute = SettingsAccountProfileRouteImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountSecurityRoute = SettingsAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountShortcutsRoute =
  SettingsAccountShortcutsRouteImport.update({
    id: '/account/shortcuts',
    path: '/account/shortcuts',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsIndexRoute = SettingsSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsActionLibraryRoute =
  SettingsSettingsActionLibraryRouteImport.update({
    id: '/settings/action-library',
    path: '/settings/action-library',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsAiRoute = SettingsSettingsAiRouteImport.update({
  id: '/settings/ai',
  path: '/settings/ai',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsApiRoute = SettingsSettingsApiRouteImport.update({
  id: '/settings/api',
  path: '/settings/api',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsAppsRoute = SettingsSettingsAppsRouteImport.update({
  id: '/settings/apps',
  path: '/settings/apps',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsAuditRoute = SettingsSettingsAuditRouteImport.update({
  id: '/settings/audit',
  path: '/settings/audit',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsBrandingRoute =
  SettingsSettingsBrandingRouteImport.update({
    id: '/settings/branding',
    path: '/settings/branding',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsCalendarRoute =
  SettingsSettingsCalendarRouteImport.update({
    id: '/settings/calendar',
    path: '/settings/calendar',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsComponentsRoute =
  SettingsSettingsComponentsRouteImport.update({
    id: '/settings/components',
    path: '/settings/components',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsConnectionsRoute =
  SettingsSettingsConnectionsRouteImport.update({
    id: '/settings/connections',
    path: '/settings/connections',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsDataQualityRoute =
  SettingsSettingsDataQualityRouteImport.update({
    id: '/settings/data-quality',
    path: '/settings/data-quality',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsDirectoryRoute =
  SettingsSettingsDirectoryRouteImport.update({
    id: '/settings/directory',
    path: '/settings/directory',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsEmailRoute = SettingsSettingsEmailRouteImport.update({
  id: '/settings/email',
  path: '/settings/email',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsEngagementTypesRoute =
  SettingsSettingsEngagementTypesRouteImport.update({
    id: '/settings/engagement-types',
    path: '/settings/engagement-types',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsGeneralRoute = SettingsSettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsGithubRoute = SettingsSettingsGithubRouteImport.update({
  id: '/settings/github',
  path: '/settings/github',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsImportsRoute = SettingsSettingsImportsRouteImport.update({
  id: '/settings/imports',
  path: '/settings/imports',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsInstanceRoute =
  SettingsSettingsInstanceRouteImport.update({
    id: '/settings/instance',
    path: '/settings/instance',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsJobsRoute = SettingsSettingsJobsRouteImport.update({
  id: '/settings/jobs',
  path: '/settings/jobs',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsMailLogRoute = SettingsSettingsMailLogRouteImport.update({
  id: '/settings/mail-log',
  path: '/settings/mail-log',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsMembersRoute = SettingsSettingsMembersRouteImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsModulesRoute = SettingsSettingsModulesRouteImport.update({
  id: '/settings/modules',
  path: '/settings/modules',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsNotificationsRoute =
  SettingsSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsOptionSetsRoute =
  SettingsSettingsOptionSetsRouteImport.update({
    id: '/settings/option-sets',
    path: '/settings/option-sets',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsRecorderRoute =
  SettingsSettingsRecorderRouteImport.update({
    id: '/settings/recorder',
    path: '/settings/recorder',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsRolesRoute = SettingsSettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsSchemaRoute = SettingsSettingsSchemaRouteImport.update({
  id: '/settings/schema',
  path: '/settings/schema',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsSecurityRoute =
  SettingsSettingsSecurityRouteImport.update({
    id: '/settings/security',
    path: '/settings/security',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsSequencesRoute =
  SettingsSettingsSequencesRouteImport.update({
    id: '/settings/sequences',
    path: '/settings/sequences',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsServiceAccountsRoute =
  SettingsSettingsServiceAccountsRouteImport.update({
    id: '/settings/service-accounts',
    path: '/settings/service-accounts',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsSignInRoute = SettingsSettingsSignInRouteImport.update({
  id: '/settings/sign-in',
  path: '/settings/sign-in',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsStorageRoute = SettingsSettingsStorageRouteImport.update({
  id: '/settings/storage',
  path: '/settings/storage',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsTaskTypesRoute =
  SettingsSettingsTaskTypesRouteImport.update({
    id: '/settings/task-types',
    path: '/settings/task-types',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsTeamsRoute = SettingsSettingsTeamsRouteImport.update({
  id: '/settings/teams',
  path: '/settings/teams',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingsWorkflowsRoute =
  SettingsSettingsWorkflowsRouteImport.update({
    id: '/settings/workflows',
    path: '/settings/workflows',
    getParentRoute: () => SettingsRoute,
  } as any)
const AppDocumentsGeneratedJobIdRoute =
  AppDocumentsGeneratedJobIdRouteImport.update({
    id: '/documents/generated/$jobId',
    path: '/documents/generated/$jobId',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocumentsVariantsTemplateIdRoute =
  AppDocumentsVariantsTemplateIdRouteImport.update({
    id: '/documents/variants/$templateId',
    path: '/documents/variants/$templateId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeetingsRecordingsIndexRoute =
  AppMeetingsRecordingsIndexRouteImport.update({
    id: '/meetings/recordings/',
    path: '/meetings/recordings/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeetingsRecordingsIdRoute = AppMeetingsRecordingsIdRouteImport.update({
  id: '/meetings/recordings/$id',
  path: '/meetings/recordings/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsTypesTypeIdRoute = AppMeetingsTypesTypeIdRouteImport.update({
  id: '/meetings/types/$typeId',
  path: '/meetings/types/$typeId',
  getParentRoute: () => AppRoute,
} as any)
const AppOObjectIndexRoute = AppOObjectIndexRouteImport.update({
  id: '/o/$object/',
  path: '/o/$object/',
  getParentRoute: () => AppRoute,
} as any)
const AppOObjectNewRoute = AppOObjectNewRouteImport.update({
  id: '/o/$object/new',
  path: '/o/$object/new',
  getParentRoute: () => AppRoute,
} as any)
const FocusAutomationsWorkflowIdIndexRoute =
  FocusAutomationsWorkflowIdIndexRouteImport.update({
    id: '/automations/$workflowId/',
    path: '/automations/$workflowId/',
    getParentRoute: () => FocusRoute,
  } as any)
const FocusOObjectImportRoute = FocusOObjectImportRouteImport.update({
  id: '/o/$object/import',
  path: '/o/$object/import',
  getParentRoute: () => FocusRoute,
} as any)
const SettingsSettingsBlueprintsIndexRoute =
  SettingsSettingsBlueprintsIndexRouteImport.update({
    id: '/settings/blueprints/',
    path: '/settings/blueprints/',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsObjectsIndexRoute =
  SettingsSettingsObjectsIndexRouteImport.update({
    id: '/settings/objects/',
    path: '/settings/objects/',
    getParentRoute: () => SettingsRoute,
  } as any)
const AppAutomationsWorkflowIdRunsRunIdRoute =
  AppAutomationsWorkflowIdRunsRunIdRouteImport.update({
    id: '/automations/$workflowId/runs/$runId',
    path: '/automations/$workflowId/runs/$runId',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocumentsVariantTemplateIdRecordIdRoute =
  AppDocumentsVariantTemplateIdRecordIdRouteImport.update({
    id: '/documents/variant/$templateId/$recordId',
    path: '/documents/variant/$templateId/$recordId',
    getParentRoute: () => AppRoute,
  } as any)
const AppOObjectRRecordIdRoute = AppOObjectRRecordIdRouteImport.update({
  id: '/o/$object/r/$recordId',
  path: '/o/$object/r/$recordId',
  getParentRoute: () => AppRoute,
} as any)
const FocusOObjectFormsFormIdRoute = FocusOObjectFormsFormIdRouteImport.update({
  id: '/o/$object/forms/$formId',
  path: '/o/$object/forms/$formId',
  getParentRoute: () => FocusRoute,
} as any)
const FocusSettingsObjectsKeyLayoutRoute =
  FocusSettingsObjectsKeyLayoutRouteImport.update({
    id: '/settings/objects/$key/layout',
    path: '/settings/objects/$key/layout',
    getParentRoute: () => FocusRoute,
  } as any)
const FocusSettingsTaskTypesKeyLayoutRoute =
  FocusSettingsTaskTypesKeyLayoutRouteImport.update({
    id: '/settings/task-types/$key/layout',
    path: '/settings/task-types/$key/layout',
    getParentRoute: () => FocusRoute,
  } as any)
const SettingsSettingsBlueprintsKeyConfigureRoute =
  SettingsSettingsBlueprintsKeyConfigureRouteImport.update({
    id: '/settings/blueprints/$key/configure',
    path: '/settings/blueprints/$key/configure',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsBlueprintsKeyUpgradeRoute =
  SettingsSettingsBlueprintsKeyUpgradeRouteImport.update({
    id: '/settings/blueprints/$key/upgrade',
    path: '/settings/blueprints/$key/upgrade',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsObjectsKeyIndexRoute =
  SettingsSettingsObjectsKeyIndexRouteImport.update({
    id: '/settings/objects/$key/',
    path: '/settings/objects/$key/',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsSettingsObjectsKeyFieldsFieldKeyRoute =
  SettingsSettingsObjectsKeyFieldsFieldKeyRouteImport.update({
    id: '/settings/objects/$key/fields/$fieldKey',
    path: '/settings/objects/$key/fields/$fieldKey',
    getParentRoute: () => SettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-sets': typeof AppChangeSetsRoute
  '/data-quality': typeof AppDataQualityRoute
  '/imports': typeof AppImportsRoute
  '/inbox': typeof AppInboxRoute
  '/signatures': typeof AppSignaturesRoute
  '/onboarding': typeof FocusOnboardingRoute
  '/login': typeof PublicLoginRoute
  '/setup': typeof PublicSetupRoute
  '/status': typeof PublicStatusRoute
  '/verify': typeof PublicVerifyRoute
  '/apps/$key': typeof AppAppsKeyRoute
  '/automations/runs': typeof AppAutomationsRunsRoute
  '/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/documents/clauses': typeof AppDocumentsClausesRoute
  '/documents/sequences': typeof AppDocumentsSequencesRoute
  '/library/new': typeof AppLibraryNewRoute
  '/pages/$pageId': typeof AppPagesPageIdRoute
  '/components/$id': typeof FocusComponentsIdRoute
  '/decks/$deckId': typeof FocusDecksDeckIdRoute
  '/documents/$id': typeof FocusDocumentsIdRoute
  '/book/$slug': typeof PublicBookSlugRoute
  '/f/$slug': typeof PublicFSlugRoute
  '/meeting/$token': typeof PublicMeetingTokenRoute
  '/p/$token': typeof PublicPTokenRoute
  '/present/presenter': typeof PublicPresentPresenterRoute
  '/recording/$token': typeof PublicRecordingTokenRoute
  '/sign/$token': typeof PublicSignTokenRoute
  '/task/$token': typeof PublicTaskTokenRoute
  '/account/connections': typeof SettingsAccountConnectionsRoute
  '/account/notifications': typeof SettingsAccountNotificationsRoute
  '/account/preferences': typeof SettingsAccountPreferencesRoute
  '/account/profile': typeof SettingsAccountProfileRoute
  '/account/security': typeof SettingsAccountSecurityRoute
  '/account/shortcuts': typeof SettingsAccountShortcutsRoute
  '/settings/action-library': typeof SettingsSettingsActionLibraryRoute
  '/settings/ai': typeof SettingsSettingsAiRoute
  '/settings/api': typeof SettingsSettingsApiRoute
  '/settings/apps': typeof SettingsSettingsAppsRoute
  '/settings/audit': typeof SettingsSettingsAuditRoute
  '/settings/branding': typeof SettingsSettingsBrandingRoute
  '/settings/calendar': typeof SettingsSettingsCalendarRoute
  '/settings/components': typeof SettingsSettingsComponentsRoute
  '/settings/connections': typeof SettingsSettingsConnectionsRoute
  '/settings/data-quality': typeof SettingsSettingsDataQualityRoute
  '/settings/directory': typeof SettingsSettingsDirectoryRoute
  '/settings/email': typeof SettingsSettingsEmailRoute
  '/settings/engagement-types': typeof SettingsSettingsEngagementTypesRoute
  '/settings/general': typeof SettingsSettingsGeneralRoute
  '/settings/github': typeof SettingsSettingsGithubRoute
  '/settings/imports': typeof SettingsSettingsImportsRoute
  '/settings/instance': typeof SettingsSettingsInstanceRoute
  '/settings/jobs': typeof SettingsSettingsJobsRoute
  '/settings/mail-log': typeof SettingsSettingsMailLogRoute
  '/settings/members': typeof SettingsSettingsMembersRoute
  '/settings/modules': typeof SettingsSettingsModulesRoute
  '/settings/notifications': typeof SettingsSettingsNotificationsRoute
  '/settings/option-sets': typeof SettingsSettingsOptionSetsRoute
  '/settings/recorder': typeof SettingsSettingsRecorderRoute
  '/settings/roles': typeof SettingsSettingsRolesRoute
  '/settings/schema': typeof SettingsSettingsSchemaRoute
  '/settings/security': typeof SettingsSettingsSecurityRoute
  '/settings/sequences': typeof SettingsSettingsSequencesRoute
  '/settings/service-accounts': typeof SettingsSettingsServiceAccountsRoute
  '/settings/sign-in': typeof SettingsSettingsSignInRoute
  '/settings/storage': typeof SettingsSettingsStorageRoute
  '/settings/task-types': typeof SettingsSettingsTaskTypesRoute
  '/settings/teams': typeof SettingsSettingsTeamsRoute
  '/settings/workflows': typeof SettingsSettingsWorkflowsRoute
  '/apps/': typeof AppAppsIndexRoute
  '/automations/': typeof AppAutomationsIndexRoute
  '/dashboards/': typeof AppDashboardsIndexRoute
  '/engagements/': typeof AppEngagementsIndexRoute
  '/library/': typeof AppLibraryIndexRoute
  '/meetings/': typeof AppMeetingsIndexRoute
  '/pages/': typeof AppPagesIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/account/': typeof SettingsAccountIndexRoute
  '/settings/': typeof SettingsSettingsIndexRoute
  '/documents/generated/$jobId': typeof AppDocumentsGeneratedJobIdRoute
  '/documents/variants/$templateId': typeof AppDocumentsVariantsTemplateIdRoute
  '/meetings/recordings/$id': typeof AppMeetingsRecordingsIdRoute
  '/meetings/types/$typeId': typeof AppMeetingsTypesTypeIdRoute
  '/o/$object/new': typeof AppOObjectNewRoute
  '/o/$object/import': typeof FocusOObjectImportRoute
  '/meetings/recordings/': typeof AppMeetingsRecordingsIndexRoute
  '/o/$object/': typeof AppOObjectIndexRoute
  '/automations/$workflowId/': typeof FocusAutomationsWorkflowIdIndexRoute
  '/settings/blueprints/': typeof SettingsSettingsBlueprintsIndexRoute
  '/settings/objects/': typeof SettingsSettingsObjectsIndexRoute
  '/automations/$workflowId/runs/$runId': typeof AppAutomationsWorkflowIdRunsRunIdRoute
  '/documents/variant/$templateId/$recordId': typeof AppDocumentsVariantTemplateIdRecordIdRoute
  '/o/$object/r/$recordId': typeof AppOObjectRRecordIdRoute
  '/o/$object/forms/$formId': typeof FocusOObjectFormsFormIdRoute
  '/settings/objects/$key/layout': typeof FocusSettingsObjectsKeyLayoutRoute
  '/settings/task-types/$key/layout': typeof FocusSettingsTaskTypesKeyLayoutRoute
  '/settings/blueprints/$key/configure': typeof SettingsSettingsBlueprintsKeyConfigureRoute
  '/settings/blueprints/$key/upgrade': typeof SettingsSettingsBlueprintsKeyUpgradeRoute
  '/settings/objects/$key/': typeof SettingsSettingsObjectsKeyIndexRoute
  '/settings/objects/$key/fields/$fieldKey': typeof SettingsSettingsObjectsKeyFieldsFieldKeyRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/change-sets': typeof AppChangeSetsRoute
  '/data-quality': typeof AppDataQualityRoute
  '/imports': typeof AppImportsRoute
  '/inbox': typeof AppInboxRoute
  '/signatures': typeof AppSignaturesRoute
  '/onboarding': typeof FocusOnboardingRoute
  '/login': typeof PublicLoginRoute
  '/setup': typeof PublicSetupRoute
  '/status': typeof PublicStatusRoute
  '/verify': typeof PublicVerifyRoute
  '/apps/$key': typeof AppAppsKeyRoute
  '/automations/runs': typeof AppAutomationsRunsRoute
  '/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/documents/clauses': typeof AppDocumentsClausesRoute
  '/documents/sequences': typeof AppDocumentsSequencesRoute
  '/library/new': typeof AppLibraryNewRoute
  '/pages/$pageId': typeof AppPagesPageIdRoute
  '/components/$id': typeof FocusComponentsIdRoute
  '/decks/$deckId': typeof FocusDecksDeckIdRoute
  '/documents/$id': typeof FocusDocumentsIdRoute
  '/book/$slug': typeof PublicBookSlugRoute
  '/f/$slug': typeof PublicFSlugRoute
  '/meeting/$token': typeof PublicMeetingTokenRoute
  '/p/$token': typeof PublicPTokenRoute
  '/present/presenter': typeof PublicPresentPresenterRoute
  '/recording/$token': typeof PublicRecordingTokenRoute
  '/sign/$token': typeof PublicSignTokenRoute
  '/task/$token': typeof PublicTaskTokenRoute
  '/account/connections': typeof SettingsAccountConnectionsRoute
  '/account/notifications': typeof SettingsAccountNotificationsRoute
  '/account/preferences': typeof SettingsAccountPreferencesRoute
  '/account/profile': typeof SettingsAccountProfileRoute
  '/account/security': typeof SettingsAccountSecurityRoute
  '/account/shortcuts': typeof SettingsAccountShortcutsRoute
  '/settings/action-library': typeof SettingsSettingsActionLibraryRoute
  '/settings/ai': typeof SettingsSettingsAiRoute
  '/settings/api': typeof SettingsSettingsApiRoute
  '/settings/apps': typeof SettingsSettingsAppsRoute
  '/settings/audit': typeof SettingsSettingsAuditRoute
  '/settings/branding': typeof SettingsSettingsBrandingRoute
  '/settings/calendar': typeof SettingsSettingsCalendarRoute
  '/settings/components': typeof SettingsSettingsComponentsRoute
  '/settings/connections': typeof SettingsSettingsConnectionsRoute
  '/settings/data-quality': typeof SettingsSettingsDataQualityRoute
  '/settings/directory': typeof SettingsSettingsDirectoryRoute
  '/settings/email': typeof SettingsSettingsEmailRoute
  '/settings/engagement-types': typeof SettingsSettingsEngagementTypesRoute
  '/settings/general': typeof SettingsSettingsGeneralRoute
  '/settings/github': typeof SettingsSettingsGithubRoute
  '/settings/imports': typeof SettingsSettingsImportsRoute
  '/settings/instance': typeof SettingsSettingsInstanceRoute
  '/settings/jobs': typeof SettingsSettingsJobsRoute
  '/settings/mail-log': typeof SettingsSettingsMailLogRoute
  '/settings/members': typeof SettingsSettingsMembersRoute
  '/settings/modules': typeof SettingsSettingsModulesRoute
  '/settings/notifications': typeof SettingsSettingsNotificationsRoute
  '/settings/option-sets': typeof SettingsSettingsOptionSetsRoute
  '/settings/recorder': typeof SettingsSettingsRecorderRoute
  '/settings/roles': typeof SettingsSettingsRolesRoute
  '/settings/schema': typeof SettingsSettingsSchemaRoute
  '/settings/security': typeof SettingsSettingsSecurityRoute
  '/settings/sequences': typeof SettingsSettingsSequencesRoute
  '/settings/service-accounts': typeof SettingsSettingsServiceAccountsRoute
  '/settings/sign-in': typeof SettingsSettingsSignInRoute
  '/settings/storage': typeof SettingsSettingsStorageRoute
  '/settings/task-types': typeof SettingsSettingsTaskTypesRoute
  '/settings/teams': typeof SettingsSettingsTeamsRoute
  '/settings/workflows': typeof SettingsSettingsWorkflowsRoute
  '/apps': typeof AppAppsIndexRoute
  '/automations': typeof AppAutomationsIndexRoute
  '/dashboards': typeof AppDashboardsIndexRoute
  '/engagements': typeof AppEngagementsIndexRoute
  '/library': typeof AppLibraryIndexRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/pages': typeof AppPagesIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/account': typeof SettingsAccountIndexRoute
  '/settings': typeof SettingsSettingsIndexRoute
  '/documents/generated/$jobId': typeof AppDocumentsGeneratedJobIdRoute
  '/documents/variants/$templateId': typeof AppDocumentsVariantsTemplateIdRoute
  '/meetings/recordings/$id': typeof AppMeetingsRecordingsIdRoute
  '/meetings/types/$typeId': typeof AppMeetingsTypesTypeIdRoute
  '/o/$object/new': typeof AppOObjectNewRoute
  '/o/$object/import': typeof FocusOObjectImportRoute
  '/meetings/recordings': typeof AppMeetingsRecordingsIndexRoute
  '/o/$object': typeof AppOObjectIndexRoute
  '/automations/$workflowId': typeof FocusAutomationsWorkflowIdIndexRoute
  '/settings/blueprints': typeof SettingsSettingsBlueprintsIndexRoute
  '/settings/objects': typeof SettingsSettingsObjectsIndexRoute
  '/automations/$workflowId/runs/$runId': typeof AppAutomationsWorkflowIdRunsRunIdRoute
  '/documents/variant/$templateId/$recordId': typeof AppDocumentsVariantTemplateIdRecordIdRoute
  '/o/$object/r/$recordId': typeof AppOObjectRRecordIdRoute
  '/o/$object/forms/$formId': typeof FocusOObjectFormsFormIdRoute
  '/settings/objects/$key/layout': typeof FocusSettingsObjectsKeyLayoutRoute
  '/settings/task-types/$key/layout': typeof FocusSettingsTaskTypesKeyLayoutRoute
  '/settings/blueprints/$key/configure': typeof SettingsSettingsBlueprintsKeyConfigureRoute
  '/settings/blueprints/$key/upgrade': typeof SettingsSettingsBlueprintsKeyUpgradeRoute
  '/settings/objects/$key': typeof SettingsSettingsObjectsKeyIndexRoute
  '/settings/objects/$key/fields/$fieldKey': typeof SettingsSettingsObjectsKeyFieldsFieldKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_focus': typeof FocusRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_settings': typeof SettingsRouteWithChildren
  '/_app/change-sets': typeof AppChangeSetsRoute
  '/_app/data-quality': typeof AppDataQualityRoute
  '/_app/imports': typeof AppImportsRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/signatures': typeof AppSignaturesRoute
  '/_focus/onboarding': typeof FocusOnboardingRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/setup': typeof PublicSetupRoute
  '/_public/status': typeof PublicStatusRoute
  '/_public/verify': typeof PublicVerifyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/apps/$key': typeof AppAppsKeyRoute
  '/_app/automations/runs': typeof AppAutomationsRunsRoute
  '/_app/dashboards/$dashboardId': typeof AppDashboardsDashboardIdRoute
  '/_app/documents/clauses': typeof AppDocumentsClausesRoute
  '/_app/documents/sequences': typeof AppDocumentsSequencesRoute
  '/_app/library/new': typeof AppLibraryNewRoute
  '/_app/pages/$pageId': typeof AppPagesPageIdRoute
  '/_focus/components/$id': typeof FocusComponentsIdRoute
  '/_focus/decks/$deckId': typeof FocusDecksDeckIdRoute
  '/_focus/documents/$id': typeof FocusDocumentsIdRoute
  '/_public/book/$slug': typeof PublicBookSlugRoute
  '/_public/f/$slug': typeof PublicFSlugRoute
  '/_public/meeting/$token': typeof PublicMeetingTokenRoute
  '/_public/p/$token': typeof PublicPTokenRoute
  '/_public/present/presenter': typeof PublicPresentPresenterRoute
  '/_public/recording/$token': typeof PublicRecordingTokenRoute
  '/_public/sign/$token': typeof PublicSignTokenRoute
  '/_public/task/$token': typeof PublicTaskTokenRoute
  '/_settings/account/connections': typeof SettingsAccountConnectionsRoute
  '/_settings/account/notifications': typeof SettingsAccountNotificationsRoute
  '/_settings/account/preferences': typeof SettingsAccountPreferencesRoute
  '/_settings/account/profile': typeof SettingsAccountProfileRoute
  '/_settings/account/security': typeof SettingsAccountSecurityRoute
  '/_settings/account/shortcuts': typeof SettingsAccountShortcutsRoute
  '/_settings/settings/action-library': typeof SettingsSettingsActionLibraryRoute
  '/_settings/settings/ai': typeof SettingsSettingsAiRoute
  '/_settings/settings/api': typeof SettingsSettingsApiRoute
  '/_settings/settings/apps': typeof SettingsSettingsAppsRoute
  '/_settings/settings/audit': typeof SettingsSettingsAuditRoute
  '/_settings/settings/branding': typeof SettingsSettingsBrandingRoute
  '/_settings/settings/calendar': typeof SettingsSettingsCalendarRoute
  '/_settings/settings/components': typeof SettingsSettingsComponentsRoute
  '/_settings/settings/connections': typeof SettingsSettingsConnectionsRoute
  '/_settings/settings/data-quality': typeof SettingsSettingsDataQualityRoute
  '/_settings/settings/directory': typeof SettingsSettingsDirectoryRoute
  '/_settings/settings/email': typeof SettingsSettingsEmailRoute
  '/_settings/settings/engagement-types': typeof SettingsSettingsEngagementTypesRoute
  '/_settings/settings/general': typeof SettingsSettingsGeneralRoute
  '/_settings/settings/github': typeof SettingsSettingsGithubRoute
  '/_settings/settings/imports': typeof SettingsSettingsImportsRoute
  '/_settings/settings/instance': typeof SettingsSettingsInstanceRoute
  '/_settings/settings/jobs': typeof SettingsSettingsJobsRoute
  '/_settings/settings/mail-log': typeof SettingsSettingsMailLogRoute
  '/_settings/settings/members': typeof SettingsSettingsMembersRoute
  '/_settings/settings/modules': typeof SettingsSettingsModulesRoute
  '/_settings/settings/notifications': typeof SettingsSettingsNotificationsRoute
  '/_settings/settings/option-sets': typeof SettingsSettingsOptionSetsRoute
  '/_settings/settings/recorder': typeof SettingsSettingsRecorderRoute
  '/_settings/settings/roles': typeof SettingsSettingsRolesRoute
  '/_settings/settings/schema': typeof SettingsSettingsSchemaRoute
  '/_settings/settings/security': typeof SettingsSettingsSecurityRoute
  '/_settings/settings/sequences': typeof SettingsSettingsSequencesRoute
  '/_settings/settings/service-accounts': typeof SettingsSettingsServiceAccountsRoute
  '/_settings/settings/sign-in': typeof SettingsSettingsSignInRoute
  '/_settings/settings/storage': typeof SettingsSettingsStorageRoute
  '/_settings/settings/task-types': typeof SettingsSettingsTaskTypesRoute
  '/_settings/settings/teams': typeof SettingsSettingsTeamsRoute
  '/_settings/settings/workflows': typeof SettingsSettingsWorkflowsRoute
  '/_app/apps/': typeof AppAppsIndexRoute
  '/_app/automations/': typeof AppAutomationsIndexRoute
  '/_app/dashboards/': typeof AppDashboardsIndexRoute
  '/_app/engagements/': typeof AppEngagementsIndexRoute
  '/_app/library/': typeof AppLibraryIndexRoute
  '/_app/meetings/': typeof AppMeetingsIndexRoute
  '/_app/pages/': typeof AppPagesIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_settings/account/': typeof SettingsAccountIndexRoute
  '/_settings/settings/': typeof SettingsSettingsIndexRoute
  '/_app/documents/generated/$jobId': typeof AppDocumentsGeneratedJobIdRoute
  '/_app/documents/variants/$templateId': typeof AppDocumentsVariantsTemplateIdRoute
  '/_app/meetings/recordings/$id': typeof AppMeetingsRecordingsIdRoute
  '/_app/meetings/types/$typeId': typeof AppMeetingsTypesTypeIdRoute
  '/_app/o/$object/new': typeof AppOObjectNewRoute
  '/_focus/o/$object/import': typeof FocusOObjectImportRoute
  '/_app/meetings/recordings/': typeof AppMeetingsRecordingsIndexRoute
  '/_app/o/$object/': typeof AppOObjectIndexRoute
  '/_focus/automations/$workflowId/': typeof FocusAutomationsWorkflowIdIndexRoute
  '/_settings/settings/blueprints/': typeof SettingsSettingsBlueprintsIndexRoute
  '/_settings/settings/objects/': typeof SettingsSettingsObjectsIndexRoute
  '/_app/automations/$workflowId/runs/$runId': typeof AppAutomationsWorkflowIdRunsRunIdRoute
  '/_app/documents/variant/$templateId/$recordId': typeof AppDocumentsVariantTemplateIdRecordIdRoute
  '/_app/o/$object/r/$recordId': typeof AppOObjectRRecordIdRoute
  '/_focus/o/$object/forms/$formId': typeof FocusOObjectFormsFormIdRoute
  '/_focus/settings/objects/$key/layout': typeof FocusSettingsObjectsKeyLayoutRoute
  '/_focus/settings/task-types/$key/layout': typeof FocusSettingsTaskTypesKeyLayoutRoute
  '/_settings/settings/blueprints/$key/configure': typeof SettingsSettingsBlueprintsKeyConfigureRoute
  '/_settings/settings/blueprints/$key/upgrade': typeof SettingsSettingsBlueprintsKeyUpgradeRoute
  '/_settings/settings/objects/$key/': typeof SettingsSettingsObjectsKeyIndexRoute
  '/_settings/settings/objects/$key/fields/$fieldKey': typeof SettingsSettingsObjectsKeyFieldsFieldKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-sets'
    | '/data-quality'
    | '/imports'
    | '/inbox'
    | '/signatures'
    | '/onboarding'
    | '/login'
    | '/setup'
    | '/status'
    | '/verify'
    | '/apps/$key'
    | '/automations/runs'
    | '/dashboards/$dashboardId'
    | '/documents/clauses'
    | '/documents/sequences'
    | '/library/new'
    | '/pages/$pageId'
    | '/components/$id'
    | '/decks/$deckId'
    | '/documents/$id'
    | '/book/$slug'
    | '/f/$slug'
    | '/meeting/$token'
    | '/p/$token'
    | '/present/presenter'
    | '/recording/$token'
    | '/sign/$token'
    | '/task/$token'
    | '/account/connections'
    | '/account/notifications'
    | '/account/preferences'
    | '/account/profile'
    | '/account/security'
    | '/account/shortcuts'
    | '/settings/action-library'
    | '/settings/ai'
    | '/settings/api'
    | '/settings/apps'
    | '/settings/audit'
    | '/settings/branding'
    | '/settings/calendar'
    | '/settings/components'
    | '/settings/connections'
    | '/settings/data-quality'
    | '/settings/directory'
    | '/settings/email'
    | '/settings/engagement-types'
    | '/settings/general'
    | '/settings/github'
    | '/settings/imports'
    | '/settings/instance'
    | '/settings/jobs'
    | '/settings/mail-log'
    | '/settings/members'
    | '/settings/modules'
    | '/settings/notifications'
    | '/settings/option-sets'
    | '/settings/recorder'
    | '/settings/roles'
    | '/settings/schema'
    | '/settings/security'
    | '/settings/sequences'
    | '/settings/service-accounts'
    | '/settings/sign-in'
    | '/settings/storage'
    | '/settings/task-types'
    | '/settings/teams'
    | '/settings/workflows'
    | '/apps/'
    | '/automations/'
    | '/dashboards/'
    | '/engagements/'
    | '/library/'
    | '/meetings/'
    | '/pages/'
    | '/tasks/'
    | '/account/'
    | '/settings/'
    | '/documents/generated/$jobId'
    | '/documents/variants/$templateId'
    | '/meetings/recordings/$id'
    | '/meetings/types/$typeId'
    | '/o/$object/new'
    | '/o/$object/import'
    | '/meetings/recordings/'
    | '/o/$object/'
    | '/automations/$workflowId/'
    | '/settings/blueprints/'
    | '/settings/objects/'
    | '/automations/$workflowId/runs/$runId'
    | '/documents/variant/$templateId/$recordId'
    | '/o/$object/r/$recordId'
    | '/o/$object/forms/$formId'
    | '/settings/objects/$key/layout'
    | '/settings/task-types/$key/layout'
    | '/settings/blueprints/$key/configure'
    | '/settings/blueprints/$key/upgrade'
    | '/settings/objects/$key/'
    | '/settings/objects/$key/fields/$fieldKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change-sets'
    | '/data-quality'
    | '/imports'
    | '/inbox'
    | '/signatures'
    | '/onboarding'
    | '/login'
    | '/setup'
    | '/status'
    | '/verify'
    | '/apps/$key'
    | '/automations/runs'
    | '/dashboards/$dashboardId'
    | '/documents/clauses'
    | '/documents/sequences'
    | '/library/new'
    | '/pages/$pageId'
    | '/components/$id'
    | '/decks/$deckId'
    | '/documents/$id'
    | '/book/$slug'
    | '/f/$slug'
    | '/meeting/$token'
    | '/p/$token'
    | '/present/presenter'
    | '/recording/$token'
    | '/sign/$token'
    | '/task/$token'
    | '/account/connections'
    | '/account/notifications'
    | '/account/preferences'
    | '/account/profile'
    | '/account/security'
    | '/account/shortcuts'
    | '/settings/action-library'
    | '/settings/ai'
    | '/settings/api'
    | '/settings/apps'
    | '/settings/audit'
    | '/settings/branding'
    | '/settings/calendar'
    | '/settings/components'
    | '/settings/connections'
    | '/settings/data-quality'
    | '/settings/directory'
    | '/settings/email'
    | '/settings/engagement-types'
    | '/settings/general'
    | '/settings/github'
    | '/settings/imports'
    | '/settings/instance'
    | '/settings/jobs'
    | '/settings/mail-log'
    | '/settings/members'
    | '/settings/modules'
    | '/settings/notifications'
    | '/settings/option-sets'
    | '/settings/recorder'
    | '/settings/roles'
    | '/settings/schema'
    | '/settings/security'
    | '/settings/sequences'
    | '/settings/service-accounts'
    | '/settings/sign-in'
    | '/settings/storage'
    | '/settings/task-types'
    | '/settings/teams'
    | '/settings/workflows'
    | '/apps'
    | '/automations'
    | '/dashboards'
    | '/engagements'
    | '/library'
    | '/meetings'
    | '/pages'
    | '/tasks'
    | '/account'
    | '/settings'
    | '/documents/generated/$jobId'
    | '/documents/variants/$templateId'
    | '/meetings/recordings/$id'
    | '/meetings/types/$typeId'
    | '/o/$object/new'
    | '/o/$object/import'
    | '/meetings/recordings'
    | '/o/$object'
    | '/automations/$workflowId'
    | '/settings/blueprints'
    | '/settings/objects'
    | '/automations/$workflowId/runs/$runId'
    | '/documents/variant/$templateId/$recordId'
    | '/o/$object/r/$recordId'
    | '/o/$object/forms/$formId'
    | '/settings/objects/$key/layout'
    | '/settings/task-types/$key/layout'
    | '/settings/blueprints/$key/configure'
    | '/settings/blueprints/$key/upgrade'
    | '/settings/objects/$key'
    | '/settings/objects/$key/fields/$fieldKey'
  id:
    | '__root__'
    | '/_app'
    | '/_focus'
    | '/_public'
    | '/_settings'
    | '/_app/change-sets'
    | '/_app/data-quality'
    | '/_app/imports'
    | '/_app/inbox'
    | '/_app/signatures'
    | '/_focus/onboarding'
    | '/_public/login'
    | '/_public/setup'
    | '/_public/status'
    | '/_public/verify'
    | '/_app/'
    | '/_app/apps/$key'
    | '/_app/automations/runs'
    | '/_app/dashboards/$dashboardId'
    | '/_app/documents/clauses'
    | '/_app/documents/sequences'
    | '/_app/library/new'
    | '/_app/pages/$pageId'
    | '/_focus/components/$id'
    | '/_focus/decks/$deckId'
    | '/_focus/documents/$id'
    | '/_public/book/$slug'
    | '/_public/f/$slug'
    | '/_public/meeting/$token'
    | '/_public/p/$token'
    | '/_public/present/presenter'
    | '/_public/recording/$token'
    | '/_public/sign/$token'
    | '/_public/task/$token'
    | '/_settings/account/connections'
    | '/_settings/account/notifications'
    | '/_settings/account/preferences'
    | '/_settings/account/profile'
    | '/_settings/account/security'
    | '/_settings/account/shortcuts'
    | '/_settings/settings/action-library'
    | '/_settings/settings/ai'
    | '/_settings/settings/api'
    | '/_settings/settings/apps'
    | '/_settings/settings/audit'
    | '/_settings/settings/branding'
    | '/_settings/settings/calendar'
    | '/_settings/settings/components'
    | '/_settings/settings/connections'
    | '/_settings/settings/data-quality'
    | '/_settings/settings/directory'
    | '/_settings/settings/email'
    | '/_settings/settings/engagement-types'
    | '/_settings/settings/general'
    | '/_settings/settings/github'
    | '/_settings/settings/imports'
    | '/_settings/settings/instance'
    | '/_settings/settings/jobs'
    | '/_settings/settings/mail-log'
    | '/_settings/settings/members'
    | '/_settings/settings/modules'
    | '/_settings/settings/notifications'
    | '/_settings/settings/option-sets'
    | '/_settings/settings/recorder'
    | '/_settings/settings/roles'
    | '/_settings/settings/schema'
    | '/_settings/settings/security'
    | '/_settings/settings/sequences'
    | '/_settings/settings/service-accounts'
    | '/_settings/settings/sign-in'
    | '/_settings/settings/storage'
    | '/_settings/settings/task-types'
    | '/_settings/settings/teams'
    | '/_settings/settings/workflows'
    | '/_app/apps/'
    | '/_app/automations/'
    | '/_app/dashboards/'
    | '/_app/engagements/'
    | '/_app/library/'
    | '/_app/meetings/'
    | '/_app/pages/'
    | '/_app/tasks/'
    | '/_settings/account/'
    | '/_settings/settings/'
    | '/_app/documents/generated/$jobId'
    | '/_app/documents/variants/$templateId'
    | '/_app/meetings/recordings/$id'
    | '/_app/meetings/types/$typeId'
    | '/_app/o/$object/new'
    | '/_focus/o/$object/import'
    | '/_app/meetings/recordings/'
    | '/_app/o/$object/'
    | '/_focus/automations/$workflowId/'
    | '/_settings/settings/blueprints/'
    | '/_settings/settings/objects/'
    | '/_app/automations/$workflowId/runs/$runId'
    | '/_app/documents/variant/$templateId/$recordId'
    | '/_app/o/$object/r/$recordId'
    | '/_focus/o/$object/forms/$formId'
    | '/_focus/settings/objects/$key/layout'
    | '/_focus/settings/task-types/$key/layout'
    | '/_settings/settings/blueprints/$key/configure'
    | '/_settings/settings/blueprints/$key/upgrade'
    | '/_settings/settings/objects/$key/'
    | '/_settings/settings/objects/$key/fields/$fieldKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  FocusRoute: typeof FocusRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_focus': {
      id: '/_focus'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof FocusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_settings': {
      id: '/_settings'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/change-sets': {
      id: '/_app/change-sets'
      path: '/change-sets'
      fullPath: '/change-sets'
      preLoaderRoute: typeof AppChangeSetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-quality': {
      id: '/_app/data-quality'
      path: '/data-quality'
      fullPath: '/data-quality'
      preLoaderRoute: typeof AppDataQualityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports': {
      id: '/_app/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof AppImportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/signatures': {
      id: '/_app/signatures'
      path: '/signatures'
      fullPath: '/signatures'
      preLoaderRoute: typeof AppSignaturesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_focus/onboarding': {
      id: '/_focus/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof FocusOnboardingRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/setup': {
      id: '/_public/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof PublicSetupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/status': {
      id: '/_public/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof PublicStatusRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/verify': {
      id: '/_public/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof PublicVerifyRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/apps/': {
      id: '/_app/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppAppsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps/$key': {
      id: '/_app/apps/$key'
      path: '/apps/$key'
      fullPath: '/apps/$key'
      preLoaderRoute: typeof AppAppsKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/': {
      id: '/_app/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AppAutomationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations/runs': {
      id: '/_app/automations/runs'
      path: '/automations/runs'
      fullPath: '/automations/runs'
      preLoaderRoute: typeof AppAutomationsRunsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/': {
      id: '/_app/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof AppDashboardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/$dashboardId': {
      id: '/_app/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/dashboards/$dashboardId'
      preLoaderRoute: typeof AppDashboardsDashboardIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/clauses': {
      id: '/_app/documents/clauses'
      path: '/documents/clauses'
      fullPath: '/documents/clauses'
      preLoaderRoute: typeof AppDocumentsClausesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/sequences': {
      id: '/_app/documents/sequences'
      path: '/documents/sequences'
      fullPath: '/documents/sequences'
      preLoaderRoute: typeof AppDocumentsSequencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engagements/': {
      id: '/_app/engagements/'
      path: '/engagements'
      fullPath: '/engagements/'
      preLoaderRoute: typeof AppEngagementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library/': {
      id: '/_app/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof AppLibraryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library/new': {
      id: '/_app/library/new'
      path: '/library/new'
      fullPath: '/library/new'
      preLoaderRoute: typeof AppLibraryNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/': {
      id: '/_app/meetings/'
      path: '/meetings'
      fullPath: '/meetings/'
      preLoaderRoute: typeof AppMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pages/': {
      id: '/_app/pages/'
      path: '/pages'
      fullPath: '/pages/'
      preLoaderRoute: typeof AppPagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pages/$pageId': {
      id: '/_app/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/pages/$pageId'
      preLoaderRoute: typeof AppPagesPageIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_focus/components/$id': {
      id: '/_focus/components/$id'
      path: '/components/$id'
      fullPath: '/components/$id'
      preLoaderRoute: typeof FocusComponentsIdRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_focus/decks/$deckId': {
      id: '/_focus/decks/$deckId'
      path: '/decks/$deckId'
      fullPath: '/decks/$deckId'
      preLoaderRoute: typeof FocusDecksDeckIdRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_focus/documents/$id': {
      id: '/_focus/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof FocusDocumentsIdRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_public/book/$slug': {
      id: '/_public/book/$slug'
      path: '/book/$slug'
      fullPath: '/book/$slug'
      preLoaderRoute: typeof PublicBookSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/f/$slug': {
      id: '/_public/f/$slug'
      path: '/f/$slug'
      fullPath: '/f/$slug'
      preLoaderRoute: typeof PublicFSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/meeting/$token': {
      id: '/_public/meeting/$token'
      path: '/meeting/$token'
      fullPath: '/meeting/$token'
      preLoaderRoute: typeof PublicMeetingTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/p/$token': {
      id: '/_public/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PublicPTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/present/presenter': {
      id: '/_public/present/presenter'
      path: '/present/presenter'
      fullPath: '/present/presenter'
      preLoaderRoute: typeof PublicPresentPresenterRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/recording/$token': {
      id: '/_public/recording/$token'
      path: '/recording/$token'
      fullPath: '/recording/$token'
      preLoaderRoute: typeof PublicRecordingTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign/$token': {
      id: '/_public/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof PublicSignTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/task/$token': {
      id: '/_public/task/$token'
      path: '/task/$token'
      fullPath: '/task/$token'
      preLoaderRoute: typeof PublicTaskTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_settings/account/': {
      id: '/_settings/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof SettingsAccountIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/account/connections': {
      id: '/_settings/account/connections'
      path: '/account/connections'
      fullPath: '/account/connections'
      preLoaderRoute: typeof SettingsAccountConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/account/notifications': {
      id: '/_settings/account/notifications'
      path: '/account/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof SettingsAccountNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/account/preferences': {
      id: '/_settings/account/preferences'
      path: '/account/preferences'
      fullPath: '/account/preferences'
      preLoaderRoute: typeof SettingsAccountPreferencesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/account/profile': {
      id: '/_settings/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof SettingsAccountProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/account/security': {
      id: '/_settings/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof SettingsAccountSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/account/shortcuts': {
      id: '/_settings/account/shortcuts'
      path: '/account/shortcuts'
      fullPath: '/account/shortcuts'
      preLoaderRoute: typeof SettingsAccountShortcutsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/': {
      id: '/_settings/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsSettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/action-library': {
      id: '/_settings/settings/action-library'
      path: '/settings/action-library'
      fullPath: '/settings/action-library'
      preLoaderRoute: typeof SettingsSettingsActionLibraryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/ai': {
      id: '/_settings/settings/ai'
      path: '/settings/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof SettingsSettingsAiRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/api': {
      id: '/_settings/settings/api'
      path: '/settings/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof SettingsSettingsApiRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/apps': {
      id: '/_settings/settings/apps'
      path: '/settings/apps'
      fullPath: '/settings/apps'
      preLoaderRoute: typeof SettingsSettingsAppsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/audit': {
      id: '/_settings/settings/audit'
      path: '/settings/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof SettingsSettingsAuditRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/branding': {
      id: '/_settings/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof SettingsSettingsBrandingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/calendar': {
      id: '/_settings/settings/calendar'
      path: '/settings/calendar'
      fullPath: '/settings/calendar'
      preLoaderRoute: typeof SettingsSettingsCalendarRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/components': {
      id: '/_settings/settings/components'
      path: '/settings/components'
      fullPath: '/settings/components'
      preLoaderRoute: typeof SettingsSettingsComponentsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/connections': {
      id: '/_settings/settings/connections'
      path: '/settings/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsSettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/data-quality': {
      id: '/_settings/settings/data-quality'
      path: '/settings/data-quality'
      fullPath: '/settings/data-quality'
      preLoaderRoute: typeof SettingsSettingsDataQualityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/directory': {
      id: '/_settings/settings/directory'
      path: '/settings/directory'
      fullPath: '/settings/directory'
      preLoaderRoute: typeof SettingsSettingsDirectoryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/email': {
      id: '/_settings/settings/email'
      path: '/settings/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof SettingsSettingsEmailRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/engagement-types': {
      id: '/_settings/settings/engagement-types'
      path: '/settings/engagement-types'
      fullPath: '/settings/engagement-types'
      preLoaderRoute: typeof SettingsSettingsEngagementTypesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/general': {
      id: '/_settings/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsSettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/github': {
      id: '/_settings/settings/github'
      path: '/settings/github'
      fullPath: '/settings/github'
      preLoaderRoute: typeof SettingsSettingsGithubRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/imports': {
      id: '/_settings/settings/imports'
      path: '/settings/imports'
      fullPath: '/settings/imports'
      preLoaderRoute: typeof SettingsSettingsImportsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/instance': {
      id: '/_settings/settings/instance'
      path: '/settings/instance'
      fullPath: '/settings/instance'
      preLoaderRoute: typeof SettingsSettingsInstanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/jobs': {
      id: '/_settings/settings/jobs'
      path: '/settings/jobs'
      fullPath: '/settings/jobs'
      preLoaderRoute: typeof SettingsSettingsJobsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/mail-log': {
      id: '/_settings/settings/mail-log'
      path: '/settings/mail-log'
      fullPath: '/settings/mail-log'
      preLoaderRoute: typeof SettingsSettingsMailLogRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/members': {
      id: '/_settings/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsSettingsMembersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/modules': {
      id: '/_settings/settings/modules'
      path: '/settings/modules'
      fullPath: '/settings/modules'
      preLoaderRoute: typeof SettingsSettingsModulesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/notifications': {
      id: '/_settings/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsSettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/option-sets': {
      id: '/_settings/settings/option-sets'
      path: '/settings/option-sets'
      fullPath: '/settings/option-sets'
      preLoaderRoute: typeof SettingsSettingsOptionSetsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/recorder': {
      id: '/_settings/settings/recorder'
      path: '/settings/recorder'
      fullPath: '/settings/recorder'
      preLoaderRoute: typeof SettingsSettingsRecorderRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/roles': {
      id: '/_settings/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsSettingsRolesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/schema': {
      id: '/_settings/settings/schema'
      path: '/settings/schema'
      fullPath: '/settings/schema'
      preLoaderRoute: typeof SettingsSettingsSchemaRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/security': {
      id: '/_settings/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSettingsSecurityRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/sequences': {
      id: '/_settings/settings/sequences'
      path: '/settings/sequences'
      fullPath: '/settings/sequences'
      preLoaderRoute: typeof SettingsSettingsSequencesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/service-accounts': {
      id: '/_settings/settings/service-accounts'
      path: '/settings/service-accounts'
      fullPath: '/settings/service-accounts'
      preLoaderRoute: typeof SettingsSettingsServiceAccountsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/sign-in': {
      id: '/_settings/settings/sign-in'
      path: '/settings/sign-in'
      fullPath: '/settings/sign-in'
      preLoaderRoute: typeof SettingsSettingsSignInRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/storage': {
      id: '/_settings/settings/storage'
      path: '/settings/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof SettingsSettingsStorageRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/task-types': {
      id: '/_settings/settings/task-types'
      path: '/settings/task-types'
      fullPath: '/settings/task-types'
      preLoaderRoute: typeof SettingsSettingsTaskTypesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/teams': {
      id: '/_settings/settings/teams'
      path: '/settings/teams'
      fullPath: '/settings/teams'
      preLoaderRoute: typeof SettingsSettingsTeamsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/workflows': {
      id: '/_settings/settings/workflows'
      path: '/settings/workflows'
      fullPath: '/settings/workflows'
      preLoaderRoute: typeof SettingsSettingsWorkflowsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_app/documents/generated/$jobId': {
      id: '/_app/documents/generated/$jobId'
      path: '/documents/generated/$jobId'
      fullPath: '/documents/generated/$jobId'
      preLoaderRoute: typeof AppDocumentsGeneratedJobIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/variants/$templateId': {
      id: '/_app/documents/variants/$templateId'
      path: '/documents/variants/$templateId'
      fullPath: '/documents/variants/$templateId'
      preLoaderRoute: typeof AppDocumentsVariantsTemplateIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/recordings/': {
      id: '/_app/meetings/recordings/'
      path: '/meetings/recordings'
      fullPath: '/meetings/recordings/'
      preLoaderRoute: typeof AppMeetingsRecordingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/recordings/$id': {
      id: '/_app/meetings/recordings/$id'
      path: '/meetings/recordings/$id'
      fullPath: '/meetings/recordings/$id'
      preLoaderRoute: typeof AppMeetingsRecordingsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/types/$typeId': {
      id: '/_app/meetings/types/$typeId'
      path: '/meetings/types/$typeId'
      fullPath: '/meetings/types/$typeId'
      preLoaderRoute: typeof AppMeetingsTypesTypeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/$object/': {
      id: '/_app/o/$object/'
      path: '/o/$object'
      fullPath: '/o/$object/'
      preLoaderRoute: typeof AppOObjectIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/$object/new': {
      id: '/_app/o/$object/new'
      path: '/o/$object/new'
      fullPath: '/o/$object/new'
      preLoaderRoute: typeof AppOObjectNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_focus/automations/$workflowId/': {
      id: '/_focus/automations/$workflowId/'
      path: '/automations/$workflowId'
      fullPath: '/automations/$workflowId/'
      preLoaderRoute: typeof FocusAutomationsWorkflowIdIndexRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_focus/o/$object/import': {
      id: '/_focus/o/$object/import'
      path: '/o/$object/import'
      fullPath: '/o/$object/import'
      preLoaderRoute: typeof FocusOObjectImportRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_settings/settings/blueprints/': {
      id: '/_settings/settings/blueprints/'
      path: '/settings/blueprints'
      fullPath: '/settings/blueprints/'
      preLoaderRoute: typeof SettingsSettingsBlueprintsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/objects/': {
      id: '/_settings/settings/objects/'
      path: '/settings/objects'
      fullPath: '/settings/objects/'
      preLoaderRoute: typeof SettingsSettingsObjectsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_app/automations/$workflowId/runs/$runId': {
      id: '/_app/automations/$workflowId/runs/$runId'
      path: '/automations/$workflowId/runs/$runId'
      fullPath: '/automations/$workflowId/runs/$runId'
      preLoaderRoute: typeof AppAutomationsWorkflowIdRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/variant/$templateId/$recordId': {
      id: '/_app/documents/variant/$templateId/$recordId'
      path: '/documents/variant/$templateId/$recordId'
      fullPath: '/documents/variant/$templateId/$recordId'
      preLoaderRoute: typeof AppDocumentsVariantTemplateIdRecordIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/o/$object/r/$recordId': {
      id: '/_app/o/$object/r/$recordId'
      path: '/o/$object/r/$recordId'
      fullPath: '/o/$object/r/$recordId'
      preLoaderRoute: typeof AppOObjectRRecordIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_focus/o/$object/forms/$formId': {
      id: '/_focus/o/$object/forms/$formId'
      path: '/o/$object/forms/$formId'
      fullPath: '/o/$object/forms/$formId'
      preLoaderRoute: typeof FocusOObjectFormsFormIdRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_focus/settings/objects/$key/layout': {
      id: '/_focus/settings/objects/$key/layout'
      path: '/settings/objects/$key/layout'
      fullPath: '/settings/objects/$key/layout'
      preLoaderRoute: typeof FocusSettingsObjectsKeyLayoutRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_focus/settings/task-types/$key/layout': {
      id: '/_focus/settings/task-types/$key/layout'
      path: '/settings/task-types/$key/layout'
      fullPath: '/settings/task-types/$key/layout'
      preLoaderRoute: typeof FocusSettingsTaskTypesKeyLayoutRouteImport
      parentRoute: typeof FocusRoute
    }
    '/_settings/settings/blueprints/$key/configure': {
      id: '/_settings/settings/blueprints/$key/configure'
      path: '/settings/blueprints/$key/configure'
      fullPath: '/settings/blueprints/$key/configure'
      preLoaderRoute: typeof SettingsSettingsBlueprintsKeyConfigureRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/blueprints/$key/upgrade': {
      id: '/_settings/settings/blueprints/$key/upgrade'
      path: '/settings/blueprints/$key/upgrade'
      fullPath: '/settings/blueprints/$key/upgrade'
      preLoaderRoute: typeof SettingsSettingsBlueprintsKeyUpgradeRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/objects/$key/': {
      id: '/_settings/settings/objects/$key/'
      path: '/settings/objects/$key'
      fullPath: '/settings/objects/$key/'
      preLoaderRoute: typeof SettingsSettingsObjectsKeyIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_settings/settings/objects/$key/fields/$fieldKey': {
      id: '/_settings/settings/objects/$key/fields/$fieldKey'
      path: '/settings/objects/$key/fields/$fieldKey'
      fullPath: '/settings/objects/$key/fields/$fieldKey'
      preLoaderRoute: typeof SettingsSettingsObjectsKeyFieldsFieldKeyRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface AppRouteChildren {
  AppChangeSetsRoute: typeof AppChangeSetsRoute
  AppDataQualityRoute: typeof AppDataQualityRoute
  AppImportsRoute: typeof AppImportsRoute
  AppInboxRoute: typeof AppInboxRoute
  AppSignaturesRoute: typeof AppSignaturesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAppsKeyRoute: typeof AppAppsKeyRoute
  AppAutomationsRunsRoute: typeof AppAutomationsRunsRoute
  AppDashboardsDashboardIdRoute: typeof AppDashboardsDashboardIdRoute
  AppDocumentsClausesRoute: typeof AppDocumentsClausesRoute
  AppDocumentsSequencesRoute: typeof AppDocumentsSequencesRoute
  AppLibraryNewRoute: typeof AppLibraryNewRoute
  AppPagesPageIdRoute: typeof AppPagesPageIdRoute
  AppAppsIndexRoute: typeof AppAppsIndexRoute
  AppAutomationsIndexRoute: typeof AppAutomationsIndexRoute
  AppDashboardsIndexRoute: typeof AppDashboardsIndexRoute
  AppEngagementsIndexRoute: typeof AppEngagementsIndexRoute
  AppLibraryIndexRoute: typeof AppLibraryIndexRoute
  AppMeetingsIndexRoute: typeof AppMeetingsIndexRoute
  AppPagesIndexRoute: typeof AppPagesIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppDocumentsGeneratedJobIdRoute: typeof AppDocumentsGeneratedJobIdRoute
  AppDocumentsVariantsTemplateIdRoute: typeof AppDocumentsVariantsTemplateIdRoute
  AppMeetingsRecordingsIdRoute: typeof AppMeetingsRecordingsIdRoute
  AppMeetingsTypesTypeIdRoute: typeof AppMeetingsTypesTypeIdRoute
  AppOObjectNewRoute: typeof AppOObjectNewRoute
  AppMeetingsRecordingsIndexRoute: typeof AppMeetingsRecordingsIndexRoute
  AppOObjectIndexRoute: typeof AppOObjectIndexRoute
  AppAutomationsWorkflowIdRunsRunIdRoute: typeof AppAutomationsWorkflowIdRunsRunIdRoute
  AppDocumentsVariantTemplateIdRecordIdRoute: typeof AppDocumentsVariantTemplateIdRecordIdRoute
  AppOObjectRRecordIdRoute: typeof AppOObjectRRecordIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChangeSetsRoute: AppChangeSetsRoute,
  AppDataQualityRoute: AppDataQualityRoute,
  AppImportsRoute: AppImportsRoute,
  AppInboxRoute: AppInboxRoute,
  AppSignaturesRoute: AppSignaturesRoute,
  AppIndexRoute: AppIndexRoute,
  AppAppsKeyRoute: AppAppsKeyRoute,
  AppAutomationsRunsRoute: AppAutomationsRunsRoute,
  AppDashboardsDashboardIdRoute: AppDashboardsDashboardIdRoute,
  AppDocumentsClausesRoute: AppDocumentsClausesRoute,
  AppDocumentsSequencesRoute: AppDocumentsSequencesRoute,
  AppLibraryNewRoute: AppLibraryNewRoute,
  AppPagesPageIdRoute: AppPagesPageIdRoute,
  AppAppsIndexRoute: AppAppsIndexRoute,
  AppAutomationsIndexRoute: AppAutomationsIndexRoute,
  AppDashboardsIndexRoute: AppDashboardsIndexRoute,
  AppEngagementsIndexRoute: AppEngagementsIndexRoute,
  AppLibraryIndexRoute: AppLibraryIndexRoute,
  AppMeetingsIndexRoute: AppMeetingsIndexRoute,
  AppPagesIndexRoute: AppPagesIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppDocumentsGeneratedJobIdRoute: AppDocumentsGeneratedJobIdRoute,
  AppDocumentsVariantsTemplateIdRoute: AppDocumentsVariantsTemplateIdRoute,
  AppMeetingsRecordingsIdRoute: AppMeetingsRecordingsIdRoute,
  AppMeetingsTypesTypeIdRoute: AppMeetingsTypesTypeIdRoute,
  AppOObjectNewRoute: AppOObjectNewRoute,
  AppMeetingsRecordingsIndexRoute: AppMeetingsRecordingsIndexRoute,
  AppOObjectIndexRoute: AppOObjectIndexRoute,
  AppAutomationsWorkflowIdRunsRunIdRoute:
    AppAutomationsWorkflowIdRunsRunIdRoute,
  AppDocumentsVariantTemplateIdRecordIdRoute:
    AppDocumentsVariantTemplateIdRecordIdRoute,
  AppOObjectRRecordIdRoute: AppOObjectRRecordIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface FocusRouteChildren {
  FocusOnboardingRoute: typeof FocusOnboardingRoute
  FocusComponentsIdRoute: typeof FocusComponentsIdRoute
  FocusDecksDeckIdRoute: typeof FocusDecksDeckIdRoute
  FocusDocumentsIdRoute: typeof FocusDocumentsIdRoute
  FocusOObjectImportRoute: typeof FocusOObjectImportRoute
  FocusAutomationsWorkflowIdIndexRoute: typeof FocusAutomationsWorkflowIdIndexRoute
  FocusOObjectFormsFormIdRoute: typeof FocusOObjectFormsFormIdRoute
  FocusSettingsObjectsKeyLayoutRoute: typeof FocusSettingsObjectsKeyLayoutRoute
  FocusSettingsTaskTypesKeyLayoutRoute: typeof FocusSettingsTaskTypesKeyLayoutRoute
}

const FocusRouteChildren: FocusRouteChildren = {
  FocusOnboardingRoute: FocusOnboardingRoute,
  FocusComponentsIdRoute: FocusComponentsIdRoute,
  FocusDecksDeckIdRoute: FocusDecksDeckIdRoute,
  FocusDocumentsIdRoute: FocusDocumentsIdRoute,
  FocusOObjectImportRoute: FocusOObjectImportRoute,
  FocusAutomationsWorkflowIdIndexRoute: FocusAutomationsWorkflowIdIndexRoute,
  FocusOObjectFormsFormIdRoute: FocusOObjectFormsFormIdRoute,
  FocusSettingsObjectsKeyLayoutRoute: FocusSettingsObjectsKeyLayoutRoute,
  FocusSettingsTaskTypesKeyLayoutRoute: FocusSettingsTaskTypesKeyLayoutRoute,
}

const FocusRouteWithChildren = FocusRoute._addFileChildren(FocusRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicSetupRoute: typeof PublicSetupRoute
  PublicStatusRoute: typeof PublicStatusRoute
  PublicVerifyRoute: typeof PublicVerifyRoute
  PublicBookSlugRoute: typeof PublicBookSlugRoute
  PublicFSlugRoute: typeof PublicFSlugRoute
  PublicMeetingTokenRoute: typeof PublicMeetingTokenRoute
  PublicPTokenRoute: typeof PublicPTokenRoute
  PublicPresentPresenterRoute: typeof PublicPresentPresenterRoute
  PublicRecordingTokenRoute: typeof PublicRecordingTokenRoute
  PublicSignTokenRoute: typeof PublicSignTokenRoute
  PublicTaskTokenRoute: typeof PublicTaskTokenRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicSetupRoute: PublicSetupRoute,
  PublicStatusRoute: PublicStatusRoute,
  PublicVerifyRoute: PublicVerifyRoute,
  PublicBookSlugRoute: PublicBookSlugRoute,
  PublicFSlugRoute: PublicFSlugRoute,
  PublicMeetingTokenRoute: PublicMeetingTokenRoute,
  PublicPTokenRoute: PublicPTokenRoute,
  PublicPresentPresenterRoute: PublicPresentPresenterRoute,
  PublicRecordingTokenRoute: PublicRecordingTokenRoute,
  PublicSignTokenRoute: PublicSignTokenRoute,
  PublicTaskTokenRoute: PublicTaskTokenRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountConnectionsRoute: typeof SettingsAccountConnectionsRoute
  SettingsAccountNotificationsRoute: typeof SettingsAccountNotificationsRoute
  SettingsAccountPreferencesRoute: typeof SettingsAccountPreferencesRoute
  SettingsAccountProfileRoute: typeof SettingsAccountProfileRoute
  SettingsAccountSecurityRoute: typeof SettingsAccountSecurityRoute
  SettingsAccountShortcutsRoute: typeof SettingsAccountShortcutsRoute
  SettingsSettingsActionLibraryRoute: typeof SettingsSettingsActionLibraryRoute
  SettingsSettingsAiRoute: typeof SettingsSettingsAiRoute
  SettingsSettingsApiRoute: typeof SettingsSettingsApiRoute
  SettingsSettingsAppsRoute: typeof SettingsSettingsAppsRoute
  SettingsSettingsAuditRoute: typeof SettingsSettingsAuditRoute
  SettingsSettingsBrandingRoute: typeof SettingsSettingsBrandingRoute
  SettingsSettingsCalendarRoute: typeof SettingsSettingsCalendarRoute
  SettingsSettingsComponentsRoute: typeof SettingsSettingsComponentsRoute
  SettingsSettingsConnectionsRoute: typeof SettingsSettingsConnectionsRoute
  SettingsSettingsDataQualityRoute: typeof SettingsSettingsDataQualityRoute
  SettingsSettingsDirectoryRoute: typeof SettingsSettingsDirectoryRoute
  SettingsSettingsEmailRoute: typeof SettingsSettingsEmailRoute
  SettingsSettingsEngagementTypesRoute: typeof SettingsSettingsEngagementTypesRoute
  SettingsSettingsGeneralRoute: typeof SettingsSettingsGeneralRoute
  SettingsSettingsGithubRoute: typeof SettingsSettingsGithubRoute
  SettingsSettingsImportsRoute: typeof SettingsSettingsImportsRoute
  SettingsSettingsInstanceRoute: typeof SettingsSettingsInstanceRoute
  SettingsSettingsJobsRoute: typeof SettingsSettingsJobsRoute
  SettingsSettingsMailLogRoute: typeof SettingsSettingsMailLogRoute
  SettingsSettingsMembersRoute: typeof SettingsSettingsMembersRoute
  SettingsSettingsModulesRoute: typeof SettingsSettingsModulesRoute
  SettingsSettingsNotificationsRoute: typeof SettingsSettingsNotificationsRoute
  SettingsSettingsOptionSetsRoute: typeof SettingsSettingsOptionSetsRoute
  SettingsSettingsRecorderRoute: typeof SettingsSettingsRecorderRoute
  SettingsSettingsRolesRoute: typeof SettingsSettingsRolesRoute
  SettingsSettingsSchemaRoute: typeof SettingsSettingsSchemaRoute
  SettingsSettingsSecurityRoute: typeof SettingsSettingsSecurityRoute
  SettingsSettingsSequencesRoute: typeof SettingsSettingsSequencesRoute
  SettingsSettingsServiceAccountsRoute: typeof SettingsSettingsServiceAccountsRoute
  SettingsSettingsSignInRoute: typeof SettingsSettingsSignInRoute
  SettingsSettingsStorageRoute: typeof SettingsSettingsStorageRoute
  SettingsSettingsTaskTypesRoute: typeof SettingsSettingsTaskTypesRoute
  SettingsSettingsTeamsRoute: typeof SettingsSettingsTeamsRoute
  SettingsSettingsWorkflowsRoute: typeof SettingsSettingsWorkflowsRoute
  SettingsAccountIndexRoute: typeof SettingsAccountIndexRoute
  SettingsSettingsIndexRoute: typeof SettingsSettingsIndexRoute
  SettingsSettingsBlueprintsIndexRoute: typeof SettingsSettingsBlueprintsIndexRoute
  SettingsSettingsObjectsIndexRoute: typeof SettingsSettingsObjectsIndexRoute
  SettingsSettingsBlueprintsKeyConfigureRoute: typeof SettingsSettingsBlueprintsKeyConfigureRoute
  SettingsSettingsBlueprintsKeyUpgradeRoute: typeof SettingsSettingsBlueprintsKeyUpgradeRoute
  SettingsSettingsObjectsKeyIndexRoute: typeof SettingsSettingsObjectsKeyIndexRoute
  SettingsSettingsObjectsKeyFieldsFieldKeyRoute: typeof SettingsSettingsObjectsKeyFieldsFieldKeyRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountConnectionsRoute: SettingsAccountConnectionsRoute,
  SettingsAccountNotificationsRoute: SettingsAccountNotificationsRoute,
  SettingsAccountPreferencesRoute: SettingsAccountPreferencesRoute,
  SettingsAccountProfileRoute: SettingsAccountProfileRoute,
  SettingsAccountSecurityRoute: SettingsAccountSecurityRoute,
  SettingsAccountShortcutsRoute: SettingsAccountShortcutsRoute,
  SettingsSettingsActionLibraryRoute: SettingsSettingsActionLibraryRoute,
  SettingsSettingsAiRoute: SettingsSettingsAiRoute,
  SettingsSettingsApiRoute: SettingsSettingsApiRoute,
  SettingsSettingsAppsRoute: SettingsSettingsAppsRoute,
  SettingsSettingsAuditRoute: SettingsSettingsAuditRoute,
  SettingsSettingsBrandingRoute: SettingsSettingsBrandingRoute,
  SettingsSettingsCalendarRoute: SettingsSettingsCalendarRoute,
  SettingsSettingsComponentsRoute: SettingsSettingsComponentsRoute,
  SettingsSettingsConnectionsRoute: SettingsSettingsConnectionsRoute,
  SettingsSettingsDataQualityRoute: SettingsSettingsDataQualityRoute,
  SettingsSettingsDirectoryRoute: SettingsSettingsDirectoryRoute,
  SettingsSettingsEmailRoute: SettingsSettingsEmailRoute,
  SettingsSettingsEngagementTypesRoute: SettingsSettingsEngagementTypesRoute,
  SettingsSettingsGeneralRoute: SettingsSettingsGeneralRoute,
  SettingsSettingsGithubRoute: SettingsSettingsGithubRoute,
  SettingsSettingsImportsRoute: SettingsSettingsImportsRoute,
  SettingsSettingsInstanceRoute: SettingsSettingsInstanceRoute,
  SettingsSettingsJobsRoute: SettingsSettingsJobsRoute,
  SettingsSettingsMailLogRoute: SettingsSettingsMailLogRoute,
  SettingsSettingsMembersRoute: SettingsSettingsMembersRoute,
  SettingsSettingsModulesRoute: SettingsSettingsModulesRoute,
  SettingsSettingsNotificationsRoute: SettingsSettingsNotificationsRoute,
  SettingsSettingsOptionSetsRoute: SettingsSettingsOptionSetsRoute,
  SettingsSettingsRecorderRoute: SettingsSettingsRecorderRoute,
  SettingsSettingsRolesRoute: SettingsSettingsRolesRoute,
  SettingsSettingsSchemaRoute: SettingsSettingsSchemaRoute,
  SettingsSettingsSecurityRoute: SettingsSettingsSecurityRoute,
  SettingsSettingsSequencesRoute: SettingsSettingsSequencesRoute,
  SettingsSettingsServiceAccountsRoute: SettingsSettingsServiceAccountsRoute,
  SettingsSettingsSignInRoute: SettingsSettingsSignInRoute,
  SettingsSettingsStorageRoute: SettingsSettingsStorageRoute,
  SettingsSettingsTaskTypesRoute: SettingsSettingsTaskTypesRoute,
  SettingsSettingsTeamsRoute: SettingsSettingsTeamsRoute,
  SettingsSettingsWorkflowsRoute: SettingsSettingsWorkflowsRoute,
  SettingsAccountIndexRoute: SettingsAccountIndexRoute,
  SettingsSettingsIndexRoute: SettingsSettingsIndexRoute,
  SettingsSettingsBlueprintsIndexRoute: SettingsSettingsBlueprintsIndexRoute,
  SettingsSettingsObjectsIndexRoute: SettingsSettingsObjectsIndexRoute,
  SettingsSettingsBlueprintsKeyConfigureRoute:
    SettingsSettingsBlueprintsKeyConfigureRoute,
  SettingsSettingsBlueprintsKeyUpgradeRoute:
    SettingsSettingsBlueprintsKeyUpgradeRoute,
  SettingsSettingsObjectsKeyIndexRoute: SettingsSettingsObjectsKeyIndexRoute,
  SettingsSettingsObjectsKeyFieldsFieldKeyRoute:
    SettingsSettingsObjectsKeyFieldsFieldKeyRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  FocusRoute: FocusRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
